import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiResponse } from '../../models/api-response';
import { PasswordResetRequest } from '../../models/password-reset-request';

@Injectable({ providedIn: 'root' })
export class PasswordResetRequestsService {
  constructor(private http: HttpClient) { }

  create(email: string) {
    return this.http.post<ApiResponse<PasswordResetRequest>>(
      `${environment.apiBaseUrl}/password-reset-requests`,
      { email }
    );
  }

  getPending() {
    const params = new HttpParams().set('status', 1);

    return this.http.get<ApiResponse<PasswordResetRequest[]>>(
      `${environment.apiBaseUrl}/password-reset-requests`,
      { params }
    );
  }

  resolve(requestId: string, newPassword: string, resolutionNote: string | null) {
    return this.http.post<ApiResponse<PasswordResetRequest>>(
      `${environment.apiBaseUrl}/password-reset-requests/${requestId}/resolve`,
      {
        newPassword,
        resolutionNote
      }
    );
  }

  reject(requestId: string, note: string | null) {
    return this.http.post<ApiResponse<PasswordResetRequest>>(
      `${environment.apiBaseUrl}/password-reset-requests/${requestId}/reject`,
      { note }
    );
  }
}